import { useEffect } from 'react'
import { hideChatBubble, showChatBubble } from '../libs/TidioHelper'

export function useToggleChatBubble() {
  useEffect(() => {
    hideChatBubble()
    return () => showChatBubble()
  }, [])
}
